import { useSelector } from "react-redux";
import { ColorPalette } from "../../constants";

const CustomTooltip = ({ unit, title, value, width }) => {
    const organization = useSelector(({ auth }) => auth.organization);

  return `<div  class="bg-white ${
    width || "w-20 lg:w-32"
  } shadow p-2 rounded-sm space-y-0 pt-1 text-right">
      <span style="color: ${
        organization?.color_code
      }" class="border-bottom position-relative">${title}</span>
      <div class="mt-2 d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center tracking-tighter text-black ">
        <span class="fw-bold">${value}</span>
        <span class="text-sm">${unit}</span>
      </div>
    </div>`;
};

export default CustomTooltip;
